import { render } from "./dispatch-summary.vue?vue&type=template&id=2c5381d8&scoped=true"
import script from "./dispatch-summary.vue?vue&type=script&lang=js"
export * from "./dispatch-summary.vue?vue&type=script&lang=js"

import "./dispatch-summary.vue?vue&type=style&index=0&id=2c5381d8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5381d8"]])

export default __exports__